import { createSlice } from '@reduxjs/toolkit'
import { getStr, StrType } from '../../actions/strAction'

export interface IStr {
  companies: StrType[]
  error: any
  isLoading: boolean
}

const initialState: IStr = {
  companies: [],
  isLoading: false,
  error: '',
}

export const strSlice = createSlice({
  name: 'str',
  initialState,
  reducers: {
    clearStrError: (state) => {
      state.error = ''
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStr.pending, (state) => {
      state.isLoading = true
      state.error = ''
    })
    builder.addCase(getStr.fulfilled, (state, action) => {
      state.isLoading = false
      state.companies = action.payload
      state.error = ''
    })
    builder.addCase(getStr.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
  },
})

export const { clearStrError } = strSlice.actions

export const strReducer = strSlice.reducer
